import styled from 'styled-components';
import { Button } from 'semantic-ui-react';

export const StyledButton = styled(Button)`
  &&& {
    display: flex;
    background-color: #1b1c1d;
    color: #fff;
    transition: background-color .3s ease;
  }

`;

export const StyledLabel = styled.label`
  margin-top: 2em; 
  color: rgba(0,0,0,.87);
`;

export const ContainerDouble = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContainerSingle = styled.div`
  width: 50%;

  :first-of-type {
    padding-right: 5px;
  }

  :last-of-type {
    padding-left: 5px;
  }
`;